import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "support-categories-card__copy" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "support-categories-card__icon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-bullet-list" })
], -1 /* HOISTED */)
const _hoisted_4 = {
  key: 1,
  class: "support-categories-card__content support-categories-card__content--link"
}
const _hoisted_5 = ["href", "alt"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "support-categories-card__copy" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.childCategories.length > 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "support-categories-card__content",
        title: "Has sub-menu",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($props.onEnterCategory($props.currentCategory, $props.childCategories)))
      }, [
        _createElementVNode("img", {
          src: $props.imageUrl,
          alt: $props.imageAlt,
          class: "support-categories-card__img"
        }, null, 8 /* PROPS */, _hoisted_1),
        _createElementVNode("p", _hoisted_2, _toDisplayString($props.displayTitle), 1 /* TEXT */),
        _hoisted_3
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("a", {
          href: 'support/troubleshooting/category/' + $props.urlName,
          target: "_blank",
          alt: $props.displayTitle,
          class: "support-categories-card__link"
        }, [
          _createElementVNode("img", {
            src: $props.imageUrl,
            alt: $props.imageAlt,
            class: "support-categories-card__img"
          }, null, 8 /* PROPS */, _hoisted_6),
          _createElementVNode("p", _hoisted_7, _toDisplayString($props.displayTitle), 1 /* TEXT */)
        ], 8 /* PROPS */, _hoisted_5)
      ]))
}